module.exports = __webpack_public_path__ + "img/add.e30e8f00.svg";